import { Routes } from "@angular/router";
import { AppRoutes, RouteParams } from "src/app/enums";
import { authGuard } from "./guards/auth.guard";
import { onboardingGuard } from "./guards/onboarding.guard";
import { talkBiOnlyGuard } from "./guards/product.guard";
import { accessRequiredGuard } from "./guards/houseclaw.guard";

export const routes: Routes = [
  {
    path: `${AppRoutes.public}/:${RouteParams.publicToken}`,
    loadComponent: () => import("./pages/public-talk/public-talk").then(m => m.PublicTalkPage),
  },
  {
    path: `${AppRoutes.public}/dashboards/:${RouteParams.publicToken}`,
    loadComponent: () => import("./pages/public-dashboard/public-dashboard").then(m => m.PublicDashboardPage),
  },
  {
    path: AppRoutes.onboarding,
    loadComponent: () => import("./pages/onboarding/onboarding").then(m => m.OnboardingPage),
    canActivate: [authGuard, talkBiOnlyGuard],
  },
  {
    path: AppRoutes.accessRequired,
    loadComponent: () => import("./pages/access-required/access-required.page").then(m => m.AccessRequiredPage),
    canActivate: [authGuard, accessRequiredGuard],
  },
  {
    path: AppRoutes.empty,
    loadChildren: () => import("./pages/side-menu/side-menu.routes").then(r => r.SIDE_MENU_ROUTES),
    canActivate: [authGuard, onboardingGuard],
  },
];
